<template>
  <div>
    <CRow>
      <CCol col="8">
        <CCard>
          <CCardHeader>
            <CCardBody>
              <sl-vue-tree v-model="menus" @click="contextMenuIsVisible=false"
                           @drop="node_droped"
                           @nodecontextmenu="contextmenu"/>

            </CCardBody>

          </CCardHeader>
        </CCard>
      </CCol>
      <CCol col="4">
        <CCard>
          <CCardHeader>
            <strong>افزودن منو</strong>

          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol col="12">
                <CInput
                    v-model="name"

                    label="عنوان"
                    placeholder="عنوان"
                />
              </CCol>
            </CRow>
            <CRow>
              <CCol col="12">
                <CSelect
                    :value.sync="selected_type"
                    :options="types"
                    label="نوع منو"
                />
              </CCol>
              <CCol col="12">
                <CSelect
                    :value.sync="parent_id"
                    :options="all_menus"
                    label="منو مادر"
                />
              </CCol>
              <CCol col="12">
                <CInput
                    :value.sync="order_no"
                    label="ترتیب"
                />
              </CCol>
              <CCol col="12">
                <CLinkSelector
                    v-model="link"
                    label="لینک"
                    placeholder="لینک"

                />

                <CInput
                    v-model="link"
                    label="لینک"
                    placeholder="لینک"
                />
                <CIconSelector
                    label="ایکون"
                    v-model="selected_icon"
                />
              </CCol>
            </CRow>


          </CCardBody>
          <CCardFooter>
            <CButton v-if="status_form ==0 "
                     @click="login()"
                     type="submit" ref="submit_form" size="sm" color="primary">
              <CIcon name="cil-check-circle"/>
              افزودن منو
            </CButton>


            <CButton v-if="status_form !=0 "
                     @click="login()"
                     type="submit" ref="submit_form" size="sm" color="warning">
              <CIcon name="cil-check-circle"/>
              ویرایش منو
            </CButton>
            <CButton v-if="status_form !=0 "
                     @click="clear_edit()"
                     type="submit" ref="submit_form" size="sm" color="warning">
              <CIcon name="cil-check-circle"/>
              انصراف
            </CButton>


          </CCardFooter>
        </CCard>
      </CCol>


    </CRow>

    <div class="contextmenu" ref="contextmenu" v-show="contextMenuIsVisible">
      <div @click="editDetails(selected_node)">ویرایش منو</div>
      <div @click="delete_item_dialog(selected_node)">حذف منو</div>
      <div @click="contextMenuIsVisible=false">انصراف</div>
    </div>


  </div>

</template>

<script>
import axios from "axios";
import {bus} from '../../main';

import '../../assets/scss/sl-vue-tree-dark.css'
import SlVueTree from 'sl-vue-tree/src/sl-vue-tree.vue'

export default {
  name: 'Login',
  components: {
    SlVueTree
  },
  data() {
    return {
      contextMenuIsVisible: false,
      menus: [],
      all_menus: [],
      parent_id: 0,
      order_no: '0',
      confirm_delete_name: new Date().getTime() + "_" + this.$vnode.tag,

      name: '',
      file: '',
      selected_icon: '',
      link: '',
      previewImage: '',
      description: '',
      items: [],
      selected_type: 1,
      types: [
        {label: 'معمولی', value: 1},
        {label: 'کشویی', value: 2},
        {label: 'مگامنو', value: 3}
      ],
      fields: [
        {key: 'row', label: '#', _style: 'width:10%'},
        {key: 'نام', _style: 'width:20%'},
        {key: 'لینک', _style: 'width:20%;'},
        {key: 'نوع', _style: 'width:20%;'},
        {key: 'عملیات', _style: 'width:40%;'},
      ],
      details: [],
      selected_node: {},
      collapseDuration: 0,
      status_form: 0
    }
  }, mounted() {
    this.get_categories();
    bus.$on(this.confirm_delete_name, (data) => {
      // alert(data);
      if (data == 'true') {
        this.delete_item();

      } else {
        this.status_form = 0;
      }
    });
  }, watch: {
    '$route.params.menu_id': function (id) {
      this.get_categories();
    }
  },
  methods: {

    contextmenu(node, event) {
      var my_menu = this.menus;
      for(var i=0;i<node.path.length;i++){
        if(node.path.length-1==i){
          my_menu=my_menu[node.path[i]]
        }else{
          my_menu = my_menu[node.path[i]].children
        }
        // console.log(my_menu)

      }
      // console.log(my_menu.title)
      this.selected_node=my_menu
      // if(node.path.length==1){
      //   this.selected_node=this.menus[node.path]
      // }
      // if(node.path.length==2){
      //   this.selected_node=this.menus[node.path[0]].children[node.path[1]]
      // }
      console.log("node context",this.selected_node)
      // this.selected_node = this.menus[node.path]
      event.preventDefault();
      this.contextMenuIsVisible = true;
      const $contextMenu = this.$refs.contextmenu;
      // $contextMenu.style.left = event.clientX + 'px';
      // $contextMenu.style.top = event.clientY + 'px';
      var m = this.getMousePosition(event);
      var s = this.getScrollPosition(event);
      var client_height = document.body.clientHeight;
      var display_context = document.getElementById('context_menu');


      $contextMenu.style.left = m.x + s.x + "px";
      $contextMenu.style.top = m.y + s.y + "px";


    },
    getMousePosition(e) {
      e = e || window.event;
      var position = {
        'x': e.clientX,
        'y': e.clientY
      }
      return position;
    },
    getScrollPosition() {
      var x = 0;
      var y = 0;

      if (typeof (window.pageYOffset) == 'number') {
        x = window.pageXOffset;
        y = window.pageYOffset;
      } else if (document.documentElement && (document.documentElement.scrollLeft || document.documentElement.scrollTop)) {
        x = document.documentElement.scrollLeft;
        y = document.documentElement.scrollTop;
      } else if (document.body && (document.body.scrollLeft || document.body.scrollTop)) {
        x = document.body.scrollLeft;
        y = document.body.scrollTop;
      }

      var position = {
        'x': x,
        'y': y
      }

      return position;
    },

    editDetails(item) {
      this.contextMenuIsVisible = false;

      console.log("edit called", item)
      this.name = item.title;
      this.selected_type = item.type;
      this.parent_id =this.all_menus.filter(x=>x.value==item.id)[0].parent_id
      this.order_no =this.all_menus.filter(x=>x.value==item.id)[0].order_no
      // this.parent_id = item.parent_id;
      this.link = item.url;
      this.icon = item.icon;

      this.status_form = item.id;

    },
    clear_edit() {
      this.name = '';
      this.link = '';
      this.status_form = 0;
    },
    node_droped(data1, dat2) {
      // console.log("droped",data1);
      // console.log("droped",dat2);
      let self = this;
      const formData = new FormData()
      let url;
      url = "/api/admin/site/arrange_menu";
      formData.append("is_mobile", this.$route.params.menu_id)
      formData.append("placement", dat2.placement)
      formData.append("parent_node", dat2.node.id)
      formData.append("node", data1[0].id)


      axios.post(url, formData, {}).then((res) => {

        self.status_form = 0;

        self.get_categories();


      })
          .catch(function (error) {

            console.log(error);
          });
    },
    delete_item_dialog(item) {
      this.contextMenuIsVisible = false;

      this.$root.modal_component.show_confirm_modal('اخطار', "آیا مایل به حذف این ردیف هستید؟\n در صورت حذف زیر منو ها هم حذف میشوند", ['تایید'], this.confirm_delete_name);

      this.status_form = item.id;

    },
    delete_item() {


      let self = this;
      const formData = new FormData()
      let url;
      url = "/api/admin/site/delete_menu";


      formData.append('row_id', this.status_form);

      axios.post(url, formData, {}).then((res) => {
        if (res.data.error == 1) {
          this.$root.modal_component.show_danger_modal('خطا', res.data.msg);

        } else {
          this.$root.modal_component.show_success_modal('تایید', res.data.msg);

        }
        self.status_form = 0;

        self.get_categories();


      })
          .catch(function (error) {

            console.log(error);
          });
    },
    get_categories() {
      var self = this;
      console.log("route id " + this.$route.params.menu_id);
      var formData = new FormData();
      formData.append("is_mobile", this.$route.params.menu_id)
      axios.post('/api/admin/site/get_menu', formData, {}).then(function (response) {

        var content_cats = response.data;

        self.menus = content_cats.menus
        self.all_menus = [{label:'منو اصلی',value:0,parent_id:0,order_no:0}]
        content_cats.all_menus.forEach(function (val) {
          self.all_menus.push({
            label:val.title,
            value:val.id,
            parent_id:val.parent_id,
            order_no:val.order_no
          })
        })
      })
          .catch(function (error) {

            console.log(error);
          });

    },
    goRegister() {
      this.$router.push({path: 'register'});
    },
    goSubMenus(item, index) {
      this.$router.push({path: '/dashboard/display/menus/' + this.items[index].id});
    },

    login() {


      let self = this;
      const formData = new FormData()
      let url;
      if (this.status_form == 0) {
        url = "/api/admin/site/add_menu";

      } else {
        url = "/api/admin/site/update_menu";
        formData.append('row_id', this.status_form);

      }


      // formData.append('image', this.file)
      formData.append('title', this.name);
      formData.append('url', this.link);
      formData.append('icon', this.selected_icon);
      formData.append('order_no', this.order_no);
      formData.append('parent_id', this.parent_id);
      formData.append('type', this.selected_type);
      formData.append('is_mobile', this.$route.params.menu_id)
      // formData.append('description', this.description)
      axios.post(url, formData, {}).then((res) => {


        // if(this.status_form==0){
        //     url = "/api/admin/category";
        this.$root.modal_component.show_api_response_modals(res);

        self.name = '';
        self.link = '';
        self.description = '';
        self.previewImage = '';
        self.status_form = 0;
        self.get_categories();

      })

          .catch(function (error) {

            console.log(error);
          });

    }
  }
}


</script>
<style>
.contextmenu {
  position: absolute;
  background-color: white;
  color: black;
  border-radius: 2px;
  cursor: pointer;
}

.contextmenu > div {
  padding: 10px;
}

.contextmenu > div:hover {
  background-color: rgba(100, 100, 255, 0.5);
}
</style>